import React, { useEffect, useState } from "react";
import MaterialUI from "material-UI";
import * as Styles from "./styles";

interface Props {
  onClose: () => void;
  handleZerarPV: () => void;
  isLoadingZerarPV?: boolean;
}

const Footer: React.FC<Props> = (props) => {
  return (
    <>
      <Styles.Container>
        <Styles.BodyText>
          Ao Zerar Pv, o valor da(s) parcela(s) será recalculado para fechar a
          conta sem perda
        </Styles.BodyText>
      </Styles.Container>
      <Styles.SecondContainer>
        <Styles.Button onClick={props?.onClose}>
          <Styles.LightTextBlue>Cancelar</Styles.LightTextBlue>
        </Styles.Button>
        <Styles.ButtonBlue
          onClick={() => {
            props.handleZerarPV();
          }}
        >
          {props.isLoadingZerarPV ? (
            <MaterialUI.CircularProgress size={22} style={{ color: "#fff" }} />
          ) : (
            <Styles.LightText>Zerar PV</Styles.LightText>
          )}
        </Styles.ButtonBlue>
      </Styles.SecondContainer>
    </>
  );
};

export default Footer;
